module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "carosserie.01cc94ad.svg";